import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    height: '8vh',
    background: '#363473',
    color: 'white',
    alignItems: 'center',
    fontSize: '14px',
    fontWeight: 400,
    position: 'fixed',
    bottom: '0',
  },
  footerMargin: {
    margin: '0 100px',
    textDecoration: 'none',
  },
  footerList: {
    textDecoration: 'none',
    display: 'flex',
    '& li': {
      margin: '0 48px 0 0',
    },
    '& a': {
      textDecoration: 'none',
      color: 'white',
    },
  },
  footerRight: {
    display: 'flex',
    justifyContent: 'end',
  },
  ButtonCSS: {
    color: 'white',
    textTransform: 'initial',
  },
}));
